module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"comment.more.label":"แนบข้อมูลเพิ่ม","comment.gallery.title":"แนบไฟล์รูปภาพ หรือ วิดีโอ (ขนาดไม่เกิน 40 MB)","comment.files.title":"แนบ Log ไฟล์ (.bin) (ขนาดไม่เกิน 40 MB)"}}')
  delete Component.options._Ctor
}
